import React, { useCallback } from 'react';
import { useReportState } from 'hooks/use-report-state';
import { RouteComponentProps } from 'react-router';
import { timeLagMonitorListDuck } from 'ducks/time-lag-monitor/list';
import {
  timeLagMonitorListFilters,
  timeLagMonitorListColumns,
  TimeLagMonitorListView,
} from './TimeLagMonitorListView';
import { deleteApi } from 'util/backendapi/fetch';
import { EMPTY_FUNC } from 'util/misc';

export function TimeLagMonitorListScreen(props: RouteComponentProps) {
  const reportState = useReportState(
    props,
    timeLagMonitorListColumns({
      refreshList: EMPTY_FUNC,
      deleteTimeLagMonitor: EMPTY_FUNC,
    }),
    timeLagMonitorListFilters,
    timeLagMonitorListDuck,
    (state) => state.timeLagMonitor.list
  );

  const deleteTimeLagMonitor = useCallback(
    async (id: number) => await deleteApi(`/time-lag-monitors/${id}/`),
    []
  );

  return (
    <TimeLagMonitorListView
      reportProps={reportState}
      deleteTimeLagMonitor={deleteTimeLagMonitor}
    />
  );
}
